
    import { Component, Prop, FormComponentBase} from "@/lib";
    @Component({name:"hi-checkbox-single"})
    export default class HiCheckboxSingle extends FormComponentBase {
        @Prop({type: Boolean}) value: boolean;

    }
